import { useEffect } from 'react';
import ReactGA from 'react-ga4';

import { GOOGLE_ANALYTICS_ID } from '../../../platforms/web/src/config/clientEnvConfig';

import { useAppConfig } from './useAppConfig';

let isGAEnabled = false;

const useAnalytics = () => {
  const { isGoogleAnalytics } = useAppConfig();

  useEffect(() => {
    if (isGoogleAnalytics) {
      ReactGA.initialize(GOOGLE_ANALYTICS_ID);
      isGAEnabled = true;
    } else {
      isGAEnabled = false;
    }
  }, [isGoogleAnalytics]);
};

export const sendGAEvent = (action: string, params: Record<string, any> = {}) => {
  if (!isGAEnabled) return;

  ReactGA.event(action, {
    ...params,
    platform: 'Web',
  });
};

export default useAnalytics;
